
export default {
  list: [],
  availableAppointments: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/exam/state.js